<template>
  <ontos-ask-dialog :title="$tt(closing ? 'workspace-close-confirm' : 'workspace-reopen-confirm', {name})"
                    :message="$tt(closing ? 'workspace-close-explain' : 'workspace-reopen-explain')"
                    :actions="actions"
                    @pick="$emit($event === 'go' ? 'confirmed' : 'cancelled')"
                    @closed="$emit('cancelled')"/>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import AskDialog, {Ask} from '@/components/shared/AskDialog.vue'

/**
 * Encerrar ou reabrir um ambiente: a pergunta, com o que acontece em cada caso.
 *
 * As duas perguntas num componente só porque são a MESMA pergunta com o sentido invertido —
 * mesma caixa, mesmo par de botões, textos opostos. Separá-las em dois componentes faria duas
 * cópias do arranjo, e a primeira mudança em um deixaria o outro para trás.
 *
 * E existe como componente, e não escrito na tela, porque os dois lados do interruptor moram
 * em lugares diferentes: **encerrar** é do design do ambiente, onde a decisão se toma;
 * **reabrir** é do selo da barra, que é onde se topa com a trava e se quer a saída. Escrito nos
 * dois, o encerrar pediria confirmação e o reabrir acabaria sem ela — ou com outra.
 *
 * O chassi é o `AskDialog`, que já é o de toda pergunta do app. Daqui sai só o `confirmed`.
 */
@Component({emits: ['confirmed', 'cancelled'],
  name: 'ontos-workspace-closure-dialog',
  components: {'ontos-ask-dialog': AskDialog}
})
class WorkspaceClosureDialog extends Vue {
  /** Verdadeiro pergunta se ENCERRA; falso, se reabre. */
  @Prop({type: Boolean, required: true}) readonly closing!: boolean
  @Prop({type: String, required: true}) readonly name!: string

  /**
   * A ação à direita e o cancelar discreto, que é o arranjo de toda pergunta daqui.
   *
   * O reabrir em `primary` e o encerrar em `warning`: encerrar tira a tela do ar e merece a
   * cor que faz hesitar; reabrir devolve, e é a ação que se quer fácil.
   */
  get actions(): Ask[] {
    return [
      {
        value: 'go',
        label: this.$tt(this.closing ? 'workspace-close' : 'workspace-reopen') as string,
        icon: this.closing ? 'mdi-archive-arrow-down-outline' : 'mdi-archive-arrow-up-outline',
        color: this.closing ? 'warning' : 'primary'
      },
      {value: 'cancel', label: this.$tt('cancel') as string, icon: 'mdi-cancel', text: true}
    ]
  }
}

export default toNative(WorkspaceClosureDialog)
</script>
